/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Action_Mark_ProcessedInputs */

const vi_tea_purchase_action_mark_processed = /** @type {(inputs: Tea_Purchase_Action_Mark_ProcessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi nhận sản xuất`)
};

/**

* @param {Tea_Purchase_Action_Mark_ProcessedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_action_mark_processed = /** @type {((inputs?: Tea_Purchase_Action_Mark_ProcessedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Action_Mark_ProcessedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_action_mark_processed(inputs)
});